import React from 'react'
import CenteredLoadingSpinner from '../../../common/CenteredLoadingSpinner'

export default function SourcesCardSkeleton(): JSX.Element {
  return <CenteredLoadingSpinner />
}
